<script>
export default {
  props: {
    for: {
      type: String,
      required: false
    }
  }
};
</script>

<template>
  <label
    class="block text-lg font-medium leading-5 text-darkBlue tracking-wider"
  >
    <slot></slot>
  </label>
</template>

<style scoped></style>
